import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './WarehouseTransfers.frontend.types'

@Injectable({ providedIn: 'root' })
export class WarehouseTransfers_adjust_target_inbound_order_orderline_and_shipmentline_flowService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { adjust_packaged_amount: number, shipment_line_id: number, order_id: number, order_line_number: number }): Promise<{ reasons?: string[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.adjust_packaged_amount)) {
      missingRequiredInParams.push('\'adjust_packaged_amount\'');
    }
    if (isNil(inParams.shipment_line_id)) {
      missingRequiredInParams.push('\'shipment_line_id\'');
    }
    if (isNil(inParams.order_id)) {
      missingRequiredInParams.push('\'order_id\'');
    }
    if (isNil(inParams.order_line_number)) {
      missingRequiredInParams.push('\'order_line_number\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/WarehouseTransfers/functions/adjust_target_inbound_order_orderline_and_shipmentline_flow`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }

}

